import { styled } from 'styled-components';
import { getStatusColor } from '../utils';
import { colors } from '../../../abstracts';
import { dontForwardProps } from '../../../util';
export const DropdownContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-tzro50-0"
})(["position:relative;width:100%;&:hover + .dropdown_helper_text{color:", ";}"], ({
  fieldStatus
}) => getStatusColor('color')[fieldStatus] || colors.black);